import { SwitchProps } from '@blueprintjs/core';
import { StyledSwitch } from './Switch.styles';

type IProps = SwitchProps;

export const Switch = ({ ref, ...props }: IProps) => {
  return <StyledSwitch {...props} />;
};
